import { trustItems } from '@/mocks/data';

export default function TrustSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4">
            Atak Sistem Enerji ile Güven Veren Hizmet
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5 mb-10">
          {trustItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-3 bg-background-100 rounded-lg p-4 border border-background-200/70"
            >
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-accent-600 w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <span className="text-sm text-foreground-700 font-medium">{item.text}</span>
            </div>
          ))}
        </div>

        <div className="bg-background-100 rounded-lg p-6 md:p-8 border border-background-200/70 max-w-3xl mx-auto">
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed text-center">
            Atak Sistem Enerji olarak amacımız yalnızca ürün satmak değil; yaşam alanınıza, kullanım ihtiyacınıza ve mevcut sisteminize uygun doğru çözümü sunmaktır.
          </p>
        </div>
      </div>
    </section>
  );
}